import { Button, Descriptions, message, Result } from 'antd'
import { DataTable } from '@operations/shared';
import { adjustmentTableColumns } from '../../utils/tableColumns'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { validationExceptionAdjustmentApi } from '../../utils/apisConsts'
import React, { useState } from 'react'
import { request } from '../../../../shared/src/apis';
import { deleteExceptionAdjustmentApi } from '../../utils/apisConsts'
import { stepperMoving } from '../../stores/actions'
import { errorMessage } from '../../utils/commonStringsConsts'
import { ModalComponent } from '@operations/shared';
const DeleteExceptionAdjustmentForm = () => {
    const [resErrorContent, setResErrorContent] = useState<any>(undefined);
    const [visibleMessageModal, setVisibleMessageModal] = useState(false)
    const advance = useSelector((state: any) => state.actionsReducer.info)
    const [sendingData, setSendingData] = useState(false)
    const dispatch = useDispatch()
    const validateAdvance = async () => {
        try {
            setSendingData(true)
            const validationRes: { [key: string]: any } = await dispatch(request({
                url: `${validationExceptionAdjustmentApi}${advance?.requestID}`, method: "GET"
            }))

            setVisibleMessageModal(true)
            setSendingData(false)
            setResErrorContent(validationRes?.data)

        } catch (error: any) {
            console.log("🚀 ~ file: deleteExceptionAdjustmentForm.tsx ~ line 45 ~ deleteAdvance ~ error", error)
            message.error(errorMessage)
            setSendingData(false)
        }
    }

    const deleteAdvance = async () => {
        try {
            setSendingData(true)
            const deleteRes: { [key: string]: any } = await dispatch(request({
                url: `${deleteExceptionAdjustmentApi}${advance.requestID}`, method: "DELETE"
            }))
            if (deleteRes.data.status === 200) {
                message.success(deleteRes?.data?.message)
                dispatch(stepperMoving(0))
            } else {
                message.error(`${deleteRes?.data?.message}, Reason: ${deleteRes?.data?.message}`)
            }
            setSendingData(false)
        }
        catch (error: any) {
            console.log("🚀 ~ file: deleteExceptionAdjustmentForm.tsx ~ line 45 ~ deleteAdvance ~ error", error)
            message.error(errorMessage)
            setSendingData(false)
        }
    }

    const closeModals = () => {
        setVisibleMessageModal(false)
        setResErrorContent(undefined)
    }

    const generateErrorsTable = () => {
        const rows = resErrorContent?.data?.reasons && Array.isArray(resErrorContent?.data?.reasons) &&
            resErrorContent?.data?.reasons?.map((reason: string) => <Descriptions.Item span={4}>{reason}</Descriptions.Item>)
        const status = resErrorContent?.data?.reasons && resErrorContent?.data?.isProceed ? "warning" : resErrorContent?.data?.reasons && resErrorContent?.data?.isProceed === false ? "error" : "success"
        return <>
            <Result
                status={status}
                style={{ padding: "30px" }}
                title={<p style={{ fontSize: '18px', padding: 0 }}>{resErrorContent?.message}</p>}
            />
            <Descriptions bordered>
                {rows}
            </Descriptions>
        </>
    }

    return (
        <div style={{ padding: "30px 0" }}>
            <Descriptions
                title={`Request #${advance?.requestID}`}
                bordered
                size={'small'}
                extra={<Button className='cancelBtn' type="default" shape='round' danger onClick={validateAdvance} loading={sendingData}>Delete Advance</Button>}
            >
                <Descriptions.Item span={2} label="User ID">{advance?.userID}</Descriptions.Item>
                <Descriptions.Item span={2} label="Request Type">{`${advance?.requestType} (${Number(advance?.installments[0]?.paymentAmount) > 0 ? "Overpaid" : "Underpaid"})`}</Descriptions.Item>
                <Descriptions.Item span={2} label="Amount">{advance?.amount}</Descriptions.Item>
                <Descriptions.Item span={2} label="Number Of Months">{advance?.numberOfMonths}</Descriptions.Item>
                <Descriptions.Item span={2} label="Created At">{moment(advance?.createdAt).format("Do MMM, YYYY")}</Descriptions.Item>
            </Descriptions>

            {Array.isArray(advance?.installments) && advance?.installments?.length > 0 &&
                <div style={{ marginTop: "25px" }}>
                    <label style={{ fontWeight: "bolder", fontSize: "16px" }}>Request Installments</label>
                    <DataTable
                        columns={adjustmentTableColumns}
                        rows={advance?.installments}
                        pagination={{}}
                        loading={false}
                        scrolling={{}}
                    />
                </div>
            }

            <ModalComponent title="Validation Results" content={generateErrorsTable()}
                visibleModal={visibleMessageModal} handleAcceptModal={deleteAdvance} handleCloseModal={closeModals} okText="Delete" cancelText="Close" btnDisable={resErrorContent?.data?.isProceed === false}/>

        </div>
    )
}

export default DeleteExceptionAdjustmentForm
